import { createSlice } from "@reduxjs/toolkit";
import { resetAll } from "./baseSlice";

const initialState = {
  learningObjects: {
    query: {
      pageNo: 1,
      pageSize: 50,
      sortBy: "asc",
      sortColumn: "firstName",
      namePattern: "",
    },
    countSummary: [],
    itemSummary: [],
    list: [],
  },
  learningPrograms: {
    query: {
      pageNo: 1,
      pageSize: 50,
      sortBy: "asc",
      sortColumn: "firstName",
      namePattern: "",
    },
    countSummary: [],
    itemSummary: [],
    list: [],
  },
  learningMilestones: {
    query: {
      pageNo: 1,
      pageSize: 50,
      sortBy: "asc",
      sortColumn: "firstName",
      namePattern: "",
    },
    countSummary: [],
    itemSummary: [],
    list: [],
  },
};

const reportSlice = createSlice({
  name: "reports",
  initialState,
  extraReducers: (builder) => builder.addCase(resetAll, () => initialState),
  reducers: {
    learningObjectCountSummaryRequest: (state, action) => {
      state.learningObjects.countSummary = null;
    },
    learningObjectItemSummaryRequest: (state, action) => {
      state.learningObjects.itemSummary = null;
    },
    learningObjectCountSummarySuccess: (state, action) => {
      state.learningObjects.countSummary = action.payload.response;
    },
    learningObjectItemSummarySuccess: (state, action) => {
      state.learningObjects.itemSummary = action.payload.response;
    },
    learningObjectCountSummaryFail: (state, action) => {
      state.learningObjects.countSummary = [];
    },
    learningObjectItemSummaryFail: (state, action) => {
      state.learningObjects.itemSummary = [];
    },
    setLearningObjectQuery: (state, action) => {
      state.learningObjects.query = action.payload;
    },
    learningObjectUsersRequest: (state, action) => {
      state.learningObjects.list = null;
    },
    learningObjectUsersSuccess: (state, action) => {
      state.learningObjects.list = action.payload.response;
    },
    learningObjectUsersFail: (state, action) => {
      state.learningObjects.list = [];
    },
    learningProgramCountSummaryRequest: (state, action) => {
      state.learningPrograms.countSummary = null;
    },
    learningProgramItemSummaryRequest: (state, action) => {
      state.learningPrograms.itemSummary = null;
    },
    learningProgramCountSummarySuccess: (state, action) => {
      state.learningPrograms.countSummary = action.payload.response;
    },
    learningProgramItemSummarySuccess: (state, action) => {
      state.learningPrograms.itemSummary = action.payload.response;
    },
    learningProgramCountSummaryFail: (state, action) => {
      state.learningPrograms.countSummary = [];
    },
    learningProgramItemSummaryFail: (state, action) => {
      state.learningPrograms.itemSummary = [];
    },
    setLearningProgramQuery: (state, action) => {
      state.learningPrograms.query = action.payload;
    },
    learningProgramUsersRequest: (state, action) => {
      state.learningPrograms.list = null;
    },
    learningProgramUsersSuccess: (state, action) => {
      state.learningPrograms.list = action.payload.response;
    },
    learningProgramUsersFail: (state, action) => {
      state.learningPrograms.list = [];
    },
    learningMilestoneCountSummaryRequest: (state, action) => {
      state.learningMilestones.countSummary = null;
    },
    learningMilestoneItemSummaryRequest: (state, action) => {
      state.learningMilestones.itemSummary = null;
    },
    learningMilestoneCountSummarySuccess: (state, action) => {
      state.learningMilestones.countSummary = action.payload.response;
    },
    learningMilestoneItemSummarySuccess: (state, action) => {
      state.learningMilestones.itemSummary = action.payload.response;
    },
    learningMilestoneCountSummaryFail: (state, action) => {
      state.learningMilestones.countSummary = [];
    },
    learningMilestoneItemSummaryFail: (state, action) => {
      state.learningMilestones.itemSummary = [];
    },
    setLearningMilestoneQuery: (state, action) => {
      state.learningMilestones.query = action.payload;
    },
    learningMilestoneUsersRequest: (state, action) => {
      state.learningMilestones.list = null;
    },
    learningMilestoneUsersSuccess: (state, action) => {
      state.learningMilestones.list = action.payload.response;
    },
    learningMilestoneUsersFail: (state, action) => {
      state.learningMilestones.list = [];
    },
    learningObjectUserExcelRequest: (state, action) => {},
    learningObjectUserExcelSuccess: (state, action) => {},
    learningObjectUserExcelFail: (state, action) => {},
    learningMilestoneUserExcelRequest: (state, action) => {},
    learningMilestoneUserExcelSuccess: (state, action) => {},
    learningMilestoneUserExcelFail: (state, action) => {},
    learningProgramUserExcelRequest: (state, action) => {},
    learningProgramUserExcelSuccess: (state, action) => {},
    learningProgramUserExcelFail: (state, action) => {},
  },
});

export const {
  learningMilestoneCountSummaryFail,
  learningMilestoneCountSummaryRequest,
  learningMilestoneCountSummarySuccess,
  learningMilestoneItemSummaryFail,
  learningMilestoneItemSummaryRequest,
  learningMilestoneItemSummarySuccess,
  learningMilestoneUsersFail,
  learningMilestoneUsersRequest,
  learningMilestoneUsersSuccess,
  learningObjectCountSummaryFail,
  learningObjectCountSummaryRequest,
  learningObjectCountSummarySuccess,
  learningObjectItemSummaryFail,
  learningObjectItemSummaryRequest,
  learningObjectItemSummarySuccess,
  learningObjectUsersFail,
  learningObjectUsersRequest,
  learningObjectUsersSuccess,
  learningProgramCountSummaryFail,
  learningProgramCountSummaryRequest,
  learningProgramCountSummarySuccess,
  learningProgramItemSummaryFail,
  learningProgramItemSummaryRequest,
  learningProgramItemSummarySuccess,
  learningProgramUsersFail,
  learningProgramUsersRequest,
  learningProgramUsersSuccess,
  setLearningMilestoneQuery,
  setLearningObjectQuery,
  setLearningProgramQuery,
  learningObjectUserExcelFail,
  learningObjectUserExcelRequest,
  learningObjectUserExcelSuccess,
  learningMilestoneUserExcelFail,
  learningMilestoneUserExcelRequest,
  learningMilestoneUserExcelSuccess,
  learningProgramUserExcelFail,
  learningProgramUserExcelRequest,
  learningProgramUserExcelSuccess,
} = reportSlice.actions;
export default reportSlice.reducer;
